import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Input, List, Typography, Divider } from "antd";
import {
    PlusOutlined,
    SearchOutlined
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import CourseThumbnailCard, { CourseThumbnailCardSkeleton } from "../Components/CourseThumbnailCard/CourseThumbnailCard";
import ContentFilterPopover from "./ContentFilters/ContentFilterPopover";
const { Text } = Typography;

const MyCourses = ({ createdCollections, loading = false, filterConfig }) => {
    const history = useHistory();
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => clearTimeout(timeout);
    }, [searchTerm]);
    const coursesWithPlaceholder = [
        ...createdCollections,
        // { id: "create-course-placeholder", isCreatePlaceholder: true }
    ];
    const filteredCourses = useMemo(() => {
        const query = debouncedSearchTerm.trim().toLowerCase();
        if (!query) {
            return coursesWithPlaceholder;
        }
        return coursesWithPlaceholder.filter((collection) => {
            if (collection?.isCreatePlaceholder) {
                return true;
            }
            const title = collection?.name || "";
            return title.toLowerCase().includes(query);
        });
    }, [coursesWithPlaceholder, debouncedSearchTerm]);
    const courseSkeletonList = Array.from({ length: 6 }, (_, index) => ({ id: `course-skeleton-${index}` }));
    return (
        <>
            {/* <Card className="my-content-content-card"> */}
            <div className="my-content-panel-head">
                <div className="my-content-panel-head-title">
                    <h3>My Courses</h3>
                    <Text className="my-content-panel-subtitle" type="secondary">
                        Browse and manage your uploaded course library
                    </Text>
                </div>
                <Divider style={{ margin: "0" }} />
                <div className="my-content-toolbar">
                    <Input
                        style={{ width: "30%" }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        prefix={<SearchOutlined />}
                        placeholder="Search courses..."
                    />
                    <ContentFilterPopover
                        content={filterConfig?.content}
                        selectedTags={filterConfig?.selectedTags || []}
                        onClear={filterConfig?.onClear}
                    />
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => history.push("/collections/create")}>
                        New Course
                    </Button>
                </div>
            </div>
            <List
                grid={{
                    gutter: [16, 16],
                    xs: 1,
                    sm: 2,
                    md: 3,
                    lg: 3,
                    xl: 3,
                    xxl: 3
                }}
                dataSource={loading ? courseSkeletonList : filteredCourses}
                pagination={{
                    pageSize: 6
                }}
                renderItem={(collection, index) => {
                    if (loading) {
                        return (
                            <List.Item key={collection.id}>
                                <CourseThumbnailCardSkeleton index={index} />
                            </List.Item>
                        );
                    }

                    if (collection.isCreatePlaceholder) {
                        return (
                            <List.Item key={collection.id}>
                                <Card
                                    hoverable
                                    className="collection-card my-content-create-tile"
                                    bordered
                                    onClick={() => history.push("/collections/create")}>
                                    <Card.Meta title="+ Create Course" />
                                </Card>
                            </List.Item>
                        );
                    }

                    return (
                        <List.Item key={collection.id}>
                            <Link
                                to={`/creator/created-collections/${collection.id}`}>
                                <CourseThumbnailCard
                                    collection={collection}
                                    index={index}
                                    searchTerm={debouncedSearchTerm}
                                    onEdit={(selectedCollection) => {
                                        history.push(`/collections/${selectedCollection.id}/edit/`);
                                    }}
                                />
                            </Link>
                        </List.Item>
                    );
                }}
            />

            {/* </Card> */}
        </>
    );
};

export default MyCourses;
